import React from 'react';
import {Tabs, TabsPanelProps} from '@mantine/core';

export const EtroTabsPanel: React.FC<TabsPanelProps> = ({
  children,
  ...props
}) => {
  return <Tabs.Panel {...props}>{children}</Tabs.Panel>;
};
